import { animateScroll } from 'react-scroll';

export function scrollToRef(
  ref: React.RefObject<HTMLDivElement>,
  headerHeight = 120
) {
  animateScroll.scrollTo((ref.current?.offsetTop ?? 0) - headerHeight);
}
